import styled, { css } from 'styled-components/macro';
import { Col, Row } from '@yme/atoms/grid';
import { colorBrandYamahaGrey, colorCoreBlack900Base } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { HeadingLevel2, RegularTextLevel3 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
const customRowProps = css `
  white-space: break-spaces;
  color: ${colorCoreBlack900Base};

  ${ADAPTIVE.maxWidth.mobile} {
    justify-content: flex-start;
  }
`;
export const CustomHeadRowStyled = styled(Row) `
  ${customRowProps};
`;
export const CustomBodyRowStyled = styled(Row) `
  ${customRowProps};

  &:last-child {
    padding-bottom: 0;
  }
`;
export const TwoColumnsHeaderStyled = styled(HeadingLevel2) `
  ${({ hasDescription }) => hasDescription && 'margin-bottom: 16px;'}
`;
export const CellTextStyled = styled(RegularTextLevel3) `
  ${ADAPTIVE.maxWidth.mobile} {
    ${getTextStyles('Ubuntu', null, 14, 20)}
  }
`;
export const BorderColStyled = styled(Col) `
  height: 1px;
  background-color: ${colorBrandYamahaGrey};
  margin: 16px 0;
`;
